webpackJsonp([12],{

/***/ 258:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(589)
}
var Component = __webpack_require__(96)(
  /* script */
  __webpack_require__(551),
  /* template */
  __webpack_require__(629),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 551:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  computed: {
    defaultActive: function defaultActive() {
      return this.$route.path.replace('/home/', '');
    }
  },
  mounted: function mounted() {},

  methods: {
    handleOpen: function handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose: function handleClose(key, keyPath) {
      console.log(key, keyPath);
    }
  }
});

/***/ }),

/***/ 562:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(253)(true);
// imports


// module
exports.push([module.i, ".home_page,.tac{min-height:calc(100vh - 56px);overflow-y:hidden}.nav{height:calc(100vh - 56px);background-color:#324057;overflow-y:auto}.threeMenu{background-color:#000}.router{box-shadow:none;-webkit-animation-duration:.5s;animation-duration:.5s}.icon{padding:0 10px;font-size:20px}", "", {"version":3,"sources":["E:/mywork/math/mathManager/src/pages/home.vue"],"names":[],"mappings":"AACA,gBAEE,8BAA+B,AAC/B,iBAAmB,CACpB,AACD,KACE,0BAA2B,AAC3B,yBAA0B,AAC1B,eAAiB,CAClB,AACD,WACE,qBAAwB,CACzB,AACD,QACE,gBAAiB,AACjB,+BAAgC,AACxB,sBAAwB,CACjC,AACD,MACE,eAAgB,AAChB,cAAgB,CACjB","file":"home.vue","sourcesContent":["\n.home_page,\n.tac{\n  min-height: calc(100vh - 56px);\n  overflow-y: hidden;\n}\n.nav{\n  height: calc(100vh - 56px);\n  background-color: #324057;\n  overflow-y: auto;\n}\n.threeMenu{\n  background-color: black;\n}\n.router{\n  box-shadow: none;\n  -webkit-animation-duration: .5s;\n          animation-duration: .5s;\n}\n.icon{\n  padding: 0 10px;\n  font-size: 20px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 589:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(562);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(254)("02800b56", content, true);

/***/ }),

/***/ 629:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home_page"
  }, [_c('el-row', {
    staticClass: "tac"
  }, [_c('el-col', {
    staticClass: "nav",
    attrs: {
      "span": 4
    }
  }, [_c('el-menu', {
    staticStyle: {
      "min-height": "100%",
      "text-align": "left"
    },
    attrs: {
      "default-active": _vm.defaultActive,
      "theme": "dark",
      "router": ""
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "welcome"
    }
  }, [_c('i', {
    staticClass: "iconfont icon-gonggao icon"
  }), _vm._v("首页")]), _vm._v(" "), _c('el-submenu', {
    attrs: {
      "index": "xmlx"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('i', {
    staticClass: "iconfont icon-shuzi1 icon"
  }), _vm._v("题目")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "problemList"
    }
  }, [_vm._v("题目列表")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "createProblem"
    }
  }, [_vm._v("出题")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "prepareProblemList"
    }
  }, [_vm._v("待审核题目")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "prepareProblemListUser"
    }
  }, [_vm._v("用户提交的题目")])], 2), _vm._v(" "), _c('el-submenu', {
    attrs: {
      "index": "gzfa"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('i', {
    staticClass: "iconfont icon-shuzi2 icon"
  }), _vm._v("相关知识")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "knowledgeList"
    }
  }, [_vm._v("知识列表")])], 2), _vm._v(" "), _c('el-submenu', {
    attrs: {
      "index": "xmss"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('i', {
    staticClass: "iconfont icon-shuzi3 icon"
  }), _vm._v("辅助功能")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "managerPage"
    }
  }, [_vm._v("管理页面")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "noticePage"
    }
  }, [_vm._v("公告管理")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "upload2Oss"
    }
  }, [_vm._v("上传资源到OSS")])], 2), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "newTeamList"
    }
  }, [_c('i', {
    staticClass: "iconfont icon-weibiaoti1 icon"
  }), _vm._v("新团队审核")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "jhxm"
    }
  }, [_c('i', {
    staticClass: "iconfont icon-weibiaoti1 icon"
  }), _vm._v("注册人数统计")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "txxt"
    }
  }, [_c('i', {
    staticClass: "iconfont icon-tuxing icon"
  }), _vm._v("用户分析")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "yjjy"
    }
  }, [_c('i', {
    staticClass: "iconfont icon-tuxing icon"
  }), _vm._v("意见建议")])], 1)], 1), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "height": "calc(100vh - 56px)",
      "overflow-y": "auto",
      "overflow-x": "hidden"
    },
    attrs: {
      "span": 20
    }
  }, [_c('transition', {
    attrs: {
      "mode": "out-in",
      "enter-active-class": "animated fadeInLeft",
      "leave-active-class": "animated fadeOutRight"
    }
  }, [_c('router-view', {
    staticClass: "router"
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/12.673824dbd107c3d91bb3.js